import { createDecorator, SimNaoEnum } from 'components/form'
import { TipoLocalizacaoEnum } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { VisualizacaoMicroareasFilterFormModel } from '../model'

const meta = metaPath<VisualizacaoMicroareasFilterFormModel>()

export const createVisualizacaoMicroareaFilterCalculator = [
  createDecorator(
    {
      field: meta.animaisImovelFilter.possuiAnimais.absolutePath(),
      updates: {
        [meta.animaisImovelFilter.animaisNoImovel.absolutePath()]: (
          possuiAnimais: SimNaoEnum,
          allValues: VisualizacaoMicroareasFilterFormModel
        ) => (possuiAnimais !== SimNaoEnum.SIM ? undefined : allValues?.animaisImovelFilter?.animaisNoImovel),
      },
    },
    {
      field: meta.condicoesMoradia.tipoLocalizacao.absolutePath(),
      updates: {
        [meta.condicoesMoradia.tipoPosseTerra.absolutePath()]: (
          tipoLocalizacao: TipoLocalizacaoEnum,
          allValues: VisualizacaoMicroareasFilterFormModel
        ) => (tipoLocalizacao !== TipoLocalizacaoEnum.RURAL ? undefined : allValues?.condicoesMoradia?.tipoPosseTerra),
      },
    },
    {
      field: meta.condicoesMoradia.isEnergiaEletricaDisponivel.absolutePath(),
      updates: {
        [meta.condicoesMoradia.tipoOrigemEnergiaEletrica.absolutePath()]: (
          isEnergiaEletricaDisponivel: SimNaoEnum,
          allValues: VisualizacaoMicroareasFilterFormModel
        ) =>
          isEnergiaEletricaDisponivel !== SimNaoEnum.SIM
            ? undefined
            : allValues?.condicoesMoradia?.tipoOrigemEnergiaEletrica,
      },
    }
  ),
]
